// This is the sso-web config file
module.exports = {
    development: {
        apps: {
            // 云教材
            MOSOBUILDER: {
                returnTo: 'https://builder-dev.mbook.cc/mosobuilder/index.php/return_from_ssoweb'
            },
            // Moso Books iPad 版
            MBHDIOS: {
                returnTo: '',
            },
            // Moso Books Android 平板电脑版
            MBHDANDROID: {
                returnTo: '',
            },
            // Moso Books iPhone 版
            MBIOS: {
                returnTo: '',
            },
            // Moso Books Android 手机版
            MBANDROID: {
                returnTo: '',
            },
            // Moso Books Windows PC 版
            MBHDWIN: {
                returnTo: '',
            },
            // Moso Teach iPhone 版
            MTIOS: {
                returnTo: 'https://dev.mbook.cc/return-to-native.action',
            },
            // Moso Teach Android 手机版
            MTANDROID: {
                returnTo: 'https://dev.mbook.cc/return-to-native.action',
            },
            // Moso Teach Web 版
            MTWEB: {
                returnTo: 'https://dev.mbook.cc/mosoteach/index.php'
            },
        }
    },

    production: {
        apps: {
            MOSOBUILDER: {
                returnTo: 'https://builder.mosoteach.cn/index.php/return_from_ssoweb'
            },
            MBHDIOS: {
                returnTo: '',
            },
            MBHDANDROID: {
                returnTo: '',
            },
            MBIOS: {
                returnTo: '',
            },
            MBANDROID: {
                returnTo: '',
            },
            MBHDWIN: {
                returnTo: '',
            },
            MTIOS: {
                returnTo: 'https://sso.mosoteach.cn/return-to-native.action',
            },
            MTANDROID: {
                returnTo: 'https://sso.mosoteach.cn/return-to-native.action',
            },
            MTWEB: {
                returnTo: 'https://www.mosoteach.cn/web/index.php'
            },
        }
    }
};